import config from 'js/app/config';
import { get } from 'js/lib/user';

const isLocalDev = () => {
  return config.environment === 'development';
};

const isCourserian = () => {
  const email = get().email_address;
  if (!email) {
    return false;
  }
  const emailDomain = email.split('@')[1];
  return emailDomain === 'coursera.org' || emailDomain === 'cloud.coursera.org';
};

export { isLocalDev, isCourserian };
